import { httpClientErrorSrc176Evid404 } from '@wix/bi-logger-os-data/v2';
export function createBiLoggerWithDefaults(params) {
  const {
    environment,
    biDefaultsOverrides
  } = params;
  const biLogger = typeof params.biLoggerOrFactory === 'function' ? params.biLoggerOrFactory().logger() : params.biLoggerOrFactory;
  return {
    report(reportProps) {
      const biEvent = {
        ...reportProps,
        params: {
          ...httpClientErrorSrc176Evid404({
            artifact_id: environment.artifactId,
            full_artifact_id: environment.fullArtifactId,
            hostingEnvironment: biDefaultsOverrides == null ? void 0 : biDefaultsOverrides.hostingEnvironment
          }).params,
          ...biDefaultsOverrides,
          ...reportProps.params
        }
      };
      return biLogger.report(biEvent);
    }
  };
}
//# sourceMappingURL=createBiLoggerWithDefaults.js.map